import React, { useContext, useState } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { useHistory, Link } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import routes, { routeIconNames } from '../../routes';
import Text from 'components/Text/Text';
import { Icon, IconName } from 'components/Icon/Icon';
import classNames from 'classnames';
import style from './Crumb.module.scss';

type CrumbType = {
	path: string;
	label: string;
};
interface IProps {
	crumb: CrumbType;
	active: boolean;
}

type IconEffectType = boolean;

interface ISubRoute {
	path: string;
	name: string;
}
type SubRouteType = ISubRoute[] | null;

export const Crumb: React.FC<IProps> = ({ crumb, active }) => {
	const { entityNameForHeader, pathnamesHistory } = useContext<IAppContext>(AppContext);
	const [hasFocusEffect, setHasFocusEffect] = useState<IconEffectType>(false);
	const history = useHistory();

	const fullRouteInfo = routes.find((el) => el.path === crumb.path) || null;
	const isHaveIcon = fullRouteInfo !== null;
	const isHaveDropdown = fullRouteInfo !== null ? fullRouteInfo.subroutes.length > 0 : false;

	const crumbDropdownClasses = classNames(style.crumb, {
		[style.hasHoverEffect]: isHaveDropdown && !hasFocusEffect,
	});
	const crumbWithHoverEffectClasses = classNames(style.crumb, style.hasHoverEffect);
	const iconOfCrumbActiveClasses = classNames(style.iconOfCrumb, style.iconOfCrumbActive);

	const getMenu = (subroutes: SubRouteType) => {
		return subroutes === null ? (
			<></>
		) : (
			<Menu className={style.menu} onClick={() => setHasFocusEffect(false)}>
				{subroutes.map((el) => (
					<Menu.Item className={style.li} key={el.path}>
						<Link to={el.path}>
							<Text translationNameSpace="routes" translationKey={el.name} asFragment={true} />
						</Link>
					</Menu.Item>
				))}
			</Menu>
		);
	};

	const handleClick = (crumbPath: string) => {
		const previousPath = pathnamesHistory[pathnamesHistory.length - 2];
		const actualPath = pathnamesHistory[pathnamesHistory.length - 1];
		if (
			previousPath === crumbPath &&
			actualPath !== '/entertainment/games/categories' &&
			actualPath !== '/entertainment/games/developers' &&
			actualPath !== '/entertainment/videos/categories' &&
			actualPath !== '/entertainment/videos/studios'
		) {
			history.go(-1);
		} else {
			history.push(crumbPath);
		}
	};

	return (
		<>
			{isHaveDropdown ? (
				<Dropdown
					overlay={getMenu(fullRouteInfo !== null ? fullRouteInfo.subroutes : null)}
					onVisibleChange={setHasFocusEffect}
					trigger={['click']}
					placement="bottomLeft">
					<div className={crumbDropdownClasses}>
						<Icon name={routeIconNames[crumb.label]} className={style.iconOfCrumb} size="lg" />
						<Text
							translationNameSpace="routes"
							translationKey={crumb.label}
							translationOptions={{ name: entityNameForHeader }}
							theme="secondary"
							size="xs"
							withTooltip={true}
						/>
						<Icon name={IconName.chevronDown} className={style.iconOfCrumb} size="lg" />
					</div>
				</Dropdown>
			) : (
				<>
					{active ? (
						<>
							{isHaveIcon ? (
								<div className={style.crumb}>
									<Icon
										name={routeIconNames[crumb.label]}
										className={iconOfCrumbActiveClasses}
										size="lg"
									/>
									<Text
										translationNameSpace="routes"
										translationKey={crumb.label}
										translationOptions={{ name: entityNameForHeader }}
										theme="neutralLight"
										size="xs"
										withTooltip={true}
									/>
								</div>
							) : (
								<div className={style.crumb}>
									<Text
										translationNameSpace="routes"
										translationKey={crumb.label}
										translationOptions={{ name: entityNameForHeader }}
										theme="neutralLight"
										size="xs"
										withTooltip={true}
									/>
								</div>
							)}
						</>
					) : (
						<a onClick={() => handleClick(crumb.path)}>
							{isHaveIcon ? (
								<div className={crumbWithHoverEffectClasses}>
									<Icon name={routeIconNames[crumb.label]} className={style.iconOfCrumb} size="lg" />
									<Text
										translationNameSpace="routes"
										translationKey={crumb.label}
										translationOptions={{ name: entityNameForHeader }}
										theme="secondary"
										size="xs"
										withTooltip={true}
									/>
								</div>
							) : (
								<div className={crumbWithHoverEffectClasses}>
									<Text
										translationNameSpace="routes"
										translationKey={crumb.label}
										translationOptions={{ name: entityNameForHeader }}
										theme="secondary"
										size="xs"
										withTooltip={true}
									/>
								</div>
							)}
						</a>
					)}
				</>
			)}
		</>
	);
};
